<div class="d-flex align-items-center justify-content-center flex-column text-center">
	<img class="img-fluid"
		 alt="empty"
		 [src]="illustration"
		 [width]="illustrationSize"
		 [height]="illustrationSize">
	<h1 class="text-gray-700 mb-0 mt-3 fw-100">{{ message }}</h1>
</div>

<ng-content></ng-content>